import { useEffect } from 'react';
import { useUiPreferences } from './use-ui-preferences';

export type Theme = 'light' | 'dark';

export const useTheme = () => {
  const { prefs, updatePrefs, isUpdating } = useUiPreferences();
  
  const currentTheme = (prefs.theme as Theme) || 'light';

  useEffect(() => {
    // Apply theme class to html element
    const root = document.documentElement;
    if (currentTheme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    
    // Sync to localStorage
    localStorage.setItem('zoocertica_theme', currentTheme);
  }, [currentTheme]);

  const toggleTheme = () => {
    const newTheme: Theme = currentTheme === 'light' ? 'dark' : 'light';
    updatePrefs({ theme: newTheme });
  };

  return {
    theme: currentTheme,
    toggleTheme,
    isUpdating,
  };
};
